var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-container', {
    staticClass: "new-modal-top-nav",
    class: _vm.customClass
  }, [_c('custom-container', [_c('custom-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.includeBack,
      expression: "includeBack"
    }],
    attrs: {
      "customClass": "new-modal-top-nav-back",
      "is-disabled": _vm.backDisabled,
      "aria-label": _vm.translations.ugcModalBack
    },
    on: {
      "click": function click($event) {
        return _vm.backEvent();
      }
    },
    scopedSlots: _vm._u([{
      key: "left-icon",
      fn: function fn() {
        return [_c('custom-svg-icon', {
          attrs: {
            "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-back.svg")
          }
        })];
      },
      proxy: true
    }], null, true)
  })], 1), _c('custom-container', {
    staticClass: "new-modal-top-nav-center"
  }, [_c('custom-image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.headerImg,
      expression: "headerImg"
    }],
    attrs: {
      "customClass": [{
        'new-modal-top-nav-center-img-title': !_vm.modalTitle
      }, {
        'new-modal-top-nav-center-img-subtitle': _vm.modalTitle
      }],
      "src": "".concat(_vm.assetsPath, "/images/common/customs_logo_red.png")
    }
  }), _vm.modalTitle ? _c('custom-text', {
    attrs: {
      "elementType": "h4",
      "id": "customs-vmodal-header-title",
      "text": _vm.modalTitle
    }
  }) : _vm._e()], 1), _c('custom-container', [_c('custom-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.includeClose,
      expression: "includeClose"
    }],
    ref: "closeBtn",
    attrs: {
      "id": "close-button-startOverModal",
      "customClass": "new-modal-top-nav-close",
      "is-disabled": _vm.closeDisabled,
      "aria-label": _vm.translations.profanityCheckClose
    },
    on: {
      "click": function click($event) {
        return _vm.closeEvent();
      }
    },
    scopedSlots: _vm._u([{
      key: "left-icon",
      fn: function fn() {
        return [_c('custom-svg-icon', {
          attrs: {
            "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-close.svg")
          }
        })];
      },
      proxy: true
    }], null, true)
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }